import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = {
  role: "group",
  class: "form-group"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  class: "col-form-label col-sm-3",
  style: {"padding-left":"0px"}
}, " 카테고리 ", -1)
const _hoisted_7 = {
  class: "col-sm-12",
  style: {"padding-left":"0px"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "선택...", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "제목", -1)
const _hoisted_11 = { class: "form-group grid" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "내용", -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", null, "노출 순서", -1)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "col-sm-9" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "Show view count", -1)
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "col-sm-9" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", null, "노출 여부", -1)
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "col-sm-9" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", null, "Pin this post to Top of the Post list", -1)
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "col-sm-9" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", null, "화면 좌우 여백 없애기", -1)
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_40 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.post.category_id = $event)),
                  required: ""
                }, [
                  _hoisted_8,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (item) => {
                    return (_openBlock(), _createBlock("option", {
                      key: item.id,
                      value: item.id
                    }, _toDisplayString(item.name), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.post.category_id]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.post.title = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.post.title]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_editor, {
                ref: "customEditor",
                "set-contents": _ctx.post.desc
              }, null, 8, ["set-contents"])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.post.order = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.post.order]
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("div", _hoisted_19, [
                  _createVNode("label", _hoisted_20, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.post.show_view_count = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.show_view_count]
                    ]),
                    _hoisted_21
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  _createVNode("label", _hoisted_26, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.post.show = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.show]
                    ]),
                    _hoisted_27
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode("div", _hoisted_31, [
                  _createVNode("label", _hoisted_32, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.post.pin = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.pin]
                    ]),
                    _hoisted_33
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode("div", _hoisted_37, [
                  _createVNode("label", _hoisted_38, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.post.no_margin_layout = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.no_margin_layout]
                    ]),
                    _hoisted_39
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_40, [
              _createVNode(_component_file_upload, {
                ref: "thumbnailFile",
                "folder-name": 'pro-post'
              }, null, 512)
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "생성",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ]))
}